import { wconcept_creator_apis } from './creator_apis';
import { wconcept_dashboard_apis } from './dashboard_apis';
import { wconcept_tracking_apis } from './tracking_apis';
import { user_apis } from './user_apis';

export const apis = {
	/////////////////wconcept
	...user_apis,
	...wconcept_dashboard_apis,
	...wconcept_creator_apis,
	...wconcept_tracking_apis,
};
